function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "secure-user-management_svg__b",
  x1: "29.793%",
  x2: "74.212%",
  y1: "100%",
  y2: "-8.63%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})), /*#__PURE__*/React.createElement("path", {
  id: "secure-user-management_svg__a",
  d: "M0 0h23v44H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(54)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "secure-user-management_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#secure-user-management_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#secure-user-management_svg__b)",
  d: "M23 11.217C23 5.022 17.852 0 11.5 0 5.15 0 0 5.022 0 11.217c0 3.808 1.949 7.166 4.923 9.194L.857 44H20.68l-2.703-23.517c3.03-2.02 5.022-5.416 5.022-9.266",
  mask: "url(#secure-user-management_svg__c)"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#DCE1EC",
  strokeWidth: 8.873
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M32.8 34.663c6.31-6.31 6.31-16.542 0-22.853-6.311-6.311-16.543-6.311-22.854 0-6.311 6.31-6.311 16.542 0 22.853 6.31 6.311 16.543 6.311 22.854 0zm1.414-1.414l32.65 32.65"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.933 73.045l11.538-11.538zM40.05 62.161l11.537-11.537z"
})));

function SvgSecureUserManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77,
    height: 77
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNzciIGhlaWdodD0iNzciPjxkZWZzPjxwYXRoIGlkPSJhIiBkPSJNMCAwaDIzdjQ0SDB6Ii8+PGxpbmVhckdyYWRpZW50IGlkPSJiIiB4MT0iMjkuNzkzJSIgeDI9Ijc0LjIxMiUiIHkxPSIxMDAlIiB5Mj0iLTguNjMlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjMDA5MDdGIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjNDhENTlGIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1NCkiPjxtYXNrIGlkPSJjIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjxwYXRoIGZpbGw9InVybCgjYikiIGQ9Ik0yMyAxMS4yMTdDMjMgNS4wMjIgMTcuODUyIDAgMTEuNSAwIDUuMTUgMCAwIDUuMDIyIDAgMTEuMjE3YzAgMy44MDggMS45NDkgNy4xNjYgNC45MjMgOS4xOTRMLjg1NyA0NEgyMC42OGwtMi43MDMtMjMuNTE3YzMuMDMtMi4wMiA1LjAyMi01LjQxNiA1LjAyMi05LjI2NiIgbWFzaz0idXJsKCNjKSIvPjwvZz48ZyBzdHJva2U9IiNEQ0UxRUMiIHN0cm9rZS13aWR0aD0iOC44NzMiPjxwYXRoIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIGQ9Ik0zMi44IDM0LjY2M2M2LjMxLTYuMzEgNi4zMS0xNi41NDIgMC0yMi44NTMtNi4zMTEtNi4zMTEtMTYuNTQzLTYuMzExLTIyLjg1NCAwLTYuMzExIDYuMzEtNi4zMTEgMTYuNTQyIDAgMjIuODUzIDYuMzEgNi4zMTEgMTYuNTQzIDYuMzExIDIyLjg1NCAwem0xLjQxNC0xLjQxNGwzMi42NSAzMi42NSIvPjxwYXRoIGQ9Ik01MC45MzMgNzMuMDQ1bDExLjUzOC0xMS41Mzh6TTQwLjA1IDYyLjE2MWwxMS41MzctMTEuNTM3eiIvPjwvZz48L2c+PC9zdmc+";
export { SvgSecureUserManagement as ReactComponent };